import { render, staticRenderFns } from "./JBProposalSafes.vue?vue&type=template&id=1c72f11e"
import script from "./JBProposalSafes.vue?vue&type=script&lang=js"
export * from "./JBProposalSafes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports